import loadable from '@loadable/component'

export const Image = loadable(() => import('./Image'))
export const BackgroundImage = loadable(() => import('./BackgroundImage'))
export type { ImageProps } from './Image'
export type { BackgroundImageProps } from './BackgroundImage'
